import { Link } from "react-router-dom";

export function UsageMeter({ label, used, max, to }) {
    const pct = max ? Math.min(100, Math.round((used / max) * 100)) : 0;
    const full = used >= max;
    return (
        <div className="rounded-lg border border-line bg-card p-4" data-testid={`usage-${label}`}>
            <div className="flex items-baseline justify-between">
                <span className="text-[14px] text-subtle">{label}</span>
                <span className="tnum text-[14px] font-medium text-ink">
                    {used} de {max}
                </span>
            </div>
            <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-line">
                <div
                    className="h-full rounded-full transition-all duration-200"
                    style={{ width: `${pct}%`, background: full ? "hsl(8 55% 44%)" : "hsl(14 45% 45%)" }}
                />
            </div>
            {full && to && (
                <Link to={to} className="mt-2 inline-block text-[13px] font-medium text-terracotta hover:underline">
                    Has llegado al límite. Ver el plan completo
                </Link>
            )}
        </div>
    );
}
